import 'css-chunk:src/calendar/tooltip/CalendarTooltip.module.scss';export default {
  "tooltip": "_tooltip_9ezve_1",
  "title": "_title_9ezve_18",
  "about": "_about_9ezve_24",
  "arrow": "_arrow_9ezve_36"
};